import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const UserLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  maxWidth: '250px',

  [theme.breakpoints.down('lg')]: {
    maxWidth: '100px',
  },

  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const AvatarWrapper = styled('div')<{ isActive: boolean }>(({ theme, isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5, 3),
  cursor: 'pointer',
  height: '100%',
  backgroundColor: isActive ? theme.palette.general.darkGreen2 : 'transparent',
  zIndex: 1,

  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1.5),
  },

  '& svg': {
    transform: isActive ? 'rotate(180deg)' : '',
    marginLeft: theme.spacing(3),
  },
  '& svg > path': {
    fill: theme.palette.common.white,
  },
}));
